








import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { pageDataType } from "../types";
import FlengthText from "../components/FlengthText.vue";
import FullImg from "../components/FullImg.vue";
import BlockText from "../components/BlockText.vue";
import ContactPage from "./ContactPage.vue";
import AbtextimgBlock from '../components/AbtextimgBlock.vue';
import Landownercomp from "../components/Landownercomp.vue";
import LandImg from "../components/LandImg.vue";
import { HOST } from "../global";
import { TimelineMax, TimelineLite, Expo, Power2 } from "gsap";


@Component({
  name: "BasicPage",
  
  components: {
     title_richtext: FlengthText,
     fullwidth_image: FullImg,
    title_subtitle_richtext: BlockText,
    text_with_image_alignment: AbtextimgBlock,
    contact_form: ContactPage,
    fullwidth_image_and_text: LandImg,
    landowner_form: Landownercomp, 
    
  }
})
export default class BasicPage extends Vue {
  // @Getter("pageData") public pageData!: pageDataType;
  @Prop() pageData!: pageDataType | null;
  public HOST: string = HOST;
  public pageLoaded: boolean = false;
  
  passLoaded(){
    this.$emit('loaded');
  }
}
